/* Copyright (c) 2023 MOCA Systems, Inc. All rights reserved. */

import { ProjectLogoType } from 'src/app/app-data/state/ProjectLogoApi';
import { environment } from 'src/environments/environment-variables';

// API Routes

export const VERIFY_SSO_MIGRATION_ROUTE = `${environment.restApiUrl}/v1/internal/auth/user/verify`;

export const VALIDATE_TICKETS_ROUTE = (projectId: string) =>
	`${environment.restApiUrl}/v1/tickets/import/${projectId}/validate`;
export const IMPORT_TICKETS_ROUTE = `${environment.restApiUrl}/v1/tickets/import`;
export const IMPORT_TICKETS_LEGACY_ROUTE = (projectId: string) =>
	`${environment.restApiUrl}/v1/tickets/import/${projectId}`;

export const UPLOAD_IMPORT_TICKETS_FILE_ROUTE = `${environment.restApiUrl}/v1/uploads`;

export const UPLOAD_TICKETS_ATTACHMENTS_ROUTE = (projectId: string) =>
	`${environment.restApiUrl}/v1/tickets/${projectId}/attachments`;

export const GET_PROJECT_ORGANIZATIONS_ROUTE = (projectId: string) =>
	`${environment.restApiUrl}/v1/projects/${projectId}/organizations`;

export const UPLOAD_PROJECT_LOGO_ROUTE = (projectId: string, logoType: ProjectLogoType) =>
	`${environment.restApiUrl}/v1/projects/${projectId}/attachments/logo?logoType=${logoType}`;

export const GET_PROJECT_LOGO_ROUTE = (projectId: string, logoType: ProjectLogoType) =>
	`${environment.restApiUrl}/v1/projects/${projectId}/attachments/logo?logoType=${logoType}`;

// Procore Integration

export const PROCORE_BASE_ROUTE = `${environment.restApiUrl}/v1/integrations/procore`;

export const PROCORE_LOGIN_WITH_ACCESS_CODE_ROUTE = `${PROCORE_BASE_ROUTE}/auth/login`;

export const PROCORE_AUTHENTICATION_ROUTE = (userId: string, projectId: string, procoreProjectId: string) =>
	`${PROCORE_BASE_ROUTE}/auth/token/${userId}/${projectId}/${procoreProjectId}`;

export const PROCORE_LIST_RFI_ROUTE = (procoreProjectId: string, procoreCompanyId: string) =>
	`${PROCORE_BASE_ROUTE}/projects/${procoreProjectId}/rfis/${procoreCompanyId}`;

export const PROCORE_GET_RFI_ROUTE = (
	procoreProjectId: string,
	procoreCompanyId: string,
	procoreRFId: string
) => `${PROCORE_BASE_ROUTE}/projects/${procoreProjectId}/rfis/${procoreCompanyId}/${procoreRFId}`;

export const PROCORE_CREATE_RFI_ROUTE = (procoreProjectId: string, procoreCompanyId: string) =>
	`${PROCORE_BASE_ROUTE}/projects/${procoreProjectId}/rfis/${procoreCompanyId}`;

// Board scan/ quikplan api routes
export const UPLOAD_IMPORT_IMAGE_ROUTE = (projectId: string, jobId: string) =>
	`${environment.restApiUrl}/v1/projects/${projectId}/board-scan/jobs/${jobId}/images`;
export const START_IMPORT_IMAGE_PROCESSING_ROUTE = (projectId: string, jobId: string) =>
	`${environment.restApiUrl}/v1/projects/${projectId}/board-scan/jobs/${jobId}/digitize`;
/** load bs partial tickets into rtdb */
export const INGEST_BOARDSCAN_TICKETS_ROUTE = (projectId: string, jobId: string) =>
	`${environment.restApiUrl}/v1/projects/${projectId}/jobs/${jobId}/board-scan-tickets`;
export const IMPORT_BOARDSCAN_TICKETS_ROUTE = `${environment.restApiUrl}/v1/tickets/express-import`;
export const GET_BOARDSCAN_TICKET_IMAGE_ROUTE = (projectId: string, jobId: string, ticketId: string) =>
	`${environment.restApiUrl}/v1/projects/${projectId}/board-scan/jobs/${jobId}/tickets/${ticketId}/image`;

// Plan print api endpoints
export const UPLOAD_PLAN_PRINT_IMAGE_ROUTE = (projectId: string, jobId: string) =>
	`${environment.restApiUrl}/v1/projects/${projectId}/print-jobs/${jobId}/images`;
